import axios from "axios";
import CryptoJS from "crypto-js";

// const API_SERVER = window.HOSTS.API[process.env.NODE_ENV];
// const hostName = `http://192.168.0.64:5678`;
// const hostName = `http://192.168.0.226:7078`;
const hostName = window.HOSTS.VERIFYSLIDE[process.env.NODE_ENV]

interface ResponseData<T = any> {
  code: number;
  message: string;
  rows?: T;
  data?: T;
}

async function post<T = any>(
  url: string,
  data?: any,
  withToken = false
): Promise<ResponseData<T> | undefined> {
  try {
    const res = await axios.post(url, data, {
      headers: {
        ...{},
      },
    });
    return res as any;
  } catch (e) {
    console.log(e);
  }
}

export async function get<T = any>(
  url: string,
  params?: any,
  withToken = false
): Promise<ResponseData<T> | undefined> {
  try {
    const res = await axios
      .get(url, {
        params,
        headers: {
          ...{},
        },
      })
      .catch((e) => {
        console.log(e);
      });

    return res as any;
  } catch (e) {
    console.log(e);
  }
}

export function getPicture() {
  return get(`${hostName}/captcha/get`, {});
}
export function reqCheck(data: any) {
  return post(`${hostName}/captcha/check`, {...data});
}

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word: string, keyWord = "XwKsGlMcdPMEhR1B") {
  var key = CryptoJS.enc.Utf8.parse(keyWord);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}
